export default function ConditionalWrapper(_a) {
    var children = _a.children, wrapper = _a.wrapper, condition = _a.condition;
    if (condition !== true)
        condition = false;
    return condition ? wrapper(children) : children;
}
